interface ApiConfig {
  API_URL: string;
}

// Endpoint/bucket MinIO public (cùng bucket "pmxs" ticket-service/payout-service đang dùng) — chỉ
// dùng để ghép URL đọc trực tiếp file public (VD: DrawPrize/{issuancePlanId}.json do payout-service
// upload), không phải để upload/ghi từ client.
interface MinioConfig {
  ENDPOINT: string;
  BUCKET_NAME: string;
}

interface Config {
  api: ApiConfig;
  minio: MinioConfig;
}

const config: Config = {
  api: {
    API_URL: process.env.REACT_APP_API_URL || "https://lms-api.exo.io.vn",
  },
  minio: {
    ENDPOINT: process.env.REACT_APP_MINIO_ENDPOINT || "https://s3.vtcmobile.vn",
    BUCKET_NAME: process.env.REACT_APP_MINIO_BUCKET_NAME || "pmxs",
  },
};

export default config;
